import { TrustBanner } from "../../components/TrustBanner/TrustBanner";
import { TrustBannerImages } from "../../components/TrustBanner/TrustBannerImages";
import { usePreload } from "../../hooks";

export const EmbedTrustPlatformBanner = () => {
  usePreload(TrustBannerImages["trustpilot"].src);

  return <TrustBanner variant="trustpilot" />;
};
